const Post = () =>
  import(/* webpackChunkName: "blog-post" */ '@/pages/blog/blog/post/index.vue')

const CreatePost = () =>
  import(
    /* webpackChunkName: "blog-post" */ '@/pages/blog/blog/post/create.vue'
  )
  
const EditPost = () =>
  import(/* webpackChunkName: "blog-post" */ '@/pages/blog/blog/post/edit.vue')

export default {
  path: 'post',
  meta: {
    label: 'post',
    auth: 'post'
  },
  component: {
    name: 'Post',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BlogPostReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Post
    },
    {
      name: 'BlogCreatePost',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreatePost
    },
    {
      name: 'BlogEditPost',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditPost,
      props: true
    }
  ]
}
